import type { ReactNode } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AdPlatformsBackground from '@/components/feature/AdPlatformsBackground';

interface PageLayoutProps {
  children: ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="relative min-h-screen w-full text-foreground-950">
      <AdPlatformsBackground />
      <Navbar />
      <main className="pt-[72px]">{children}</main>
      <Footer />
    </div>
  );
}